var React = require('react');

function SearchThinIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0,-952.36218)"},React.createElement("path",{"className":"primary-fill","d":"M29,952.4c-16,0-29,13-29,29s13,29,29,29c6.9,0,13.3-2.4,18.2-6.5l25.6,25.6c1.2,1.2,3.1,1.2,4.2,0c1.2-1.2,1.2-3.1,0-4.2\n      l-25.6-25.6c4.1-5,6.5-11.3,6.5-18.2C58,965.4,45,952.4,29,952.4L29,952.4z M29,958.4c12.7,0,23,10.3,23,23s-10.3,23-23,23\n      s-23-10.3-23-23C6,968.6,16.3,958.4,29,958.4z"})));
}

SearchThinIcon.defaultProps = {"viewBox":"0 0 77.9 78","className":"icon search thin"};

module.exports = SearchThinIcon;

SearchThinIcon.default = SearchThinIcon;
